import { memo, createElement } from '@max/max';
import View from '@hfe/max-view';
import CityCardItem from './city-card-item';
import InfiniteSteper from '../infinite-steper';
import './index.scss';
const SlideCard = (props) => {
    const { cityList, onSlideEnd } = props;
    return <View className="slide-card-container">
      <InfiniteSteper cardWidth={538} data={cityList} renderItem={(card, _index, interpolateTo, isCenter) => {
        return <CityCardItem card={card}/>;
    }} onTopShow={onSlideEnd}/>
    </View>;
};
export default memo(SlideCard);
